/**
 * Concatenate address line components into a single address string
 * @param {ADDDepartment} department - Department object
 * @returns {string} - Combined address string
 */
export const buildAddress = (department) => {
	const { address1, address2, address3 } = department.address;
	return [address1, address2, address3].filter(Boolean).join(' ');
};
